module.exports = __webpack_public_path__ + "img/footprint_headless_horseshoes.acba0a42.png";